import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { ChevronRight, Home } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export const PageBanner = ({ title, breadcrumb }) => {
  const { t } = useLanguage();

  return (
    <>
      {/* Breadcrumb */}
      <div className="gov-breadcrumb">
        <Container>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0 align-items-center" style={{ fontSize: '0.875rem' }}>
              <li className="breadcrumb-item">
                <Link to="/" className="d-flex align-items-center gap-1">
                  <Home size={14} />
                  {t('nav.home')}
                </Link>
              </li>
              <li className="breadcrumb-item d-flex align-items-center" aria-current="page">
                <ChevronRight size={14} className="mx-1" style={{ opacity: 0.5 }} />
                <span style={{ color: 'hsl(var(--muted-foreground))' }}>{breadcrumb}</span>
              </li>
            </ol>
          </nav>
        </Container>
      </div>

      {/* Page Banner */}
      <div className="page-banner">
        <Container>
          <h1 style={{ 
            fontSize: '2rem', 
            fontWeight: '600', 
            marginBottom: 0,
            position: 'relative',
            zIndex: 1
          }}>
            {title}
          </h1>
        </Container>
      </div>
    </>
  );
};
